import React from 'react';

import { Box, Skeleton, VStack } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { primitive } from 'styles/constants';

// Horizontal spacing comes from the centered container so the skeleton lands on
// the same column as the loaded hero.
const SkeletonWrapper = Box.withConfig({
  paddingY: { base: '$4', md: '$8' },
});

// TODO: loading state for SimpleHomePage. It would be updated to the new design.
export const HeroSkeleton = () => {
  return (
    <CenteredRowContainer standardPadding containerStyle={styles.background}>
      <SkeletonWrapper flexDir={{ base: 'column', md: 'row-reverse' }}>
        <Box p="$6" width={{ base: '100%', md: '50%' }}>
          <Skeleton h="$48" w="$48" mb="$3" rounded="full" mx="auto" />
        </Box>
        <VStack width={{ base: '100%', md: '50%' }} justifyContent="center">
          <Skeleton.Text mb="$4" />
          <Skeleton
            h="$10"
            rounded="full"
            mb="$2"
            startColor="token.background-skeleton-loader-cta-start"
            endColor="token.background-skeleton-loader-cta-end"
          />
        </VStack>
      </SkeletonWrapper>
    </CenteredRowContainer>
  );
};

const styles = StyleSheet.create({
  background: {
    backgroundColor: primitive.$mayoEggWhite,
  },
});
